// extracted by mini-css-extract-plugin
export default {"root":"BarChart-root-bb7f","graphTitle":"BarChart-graphTitle-b308","graphSubtitle":"BarChart-graphSubtitle-a9e1","link":"BarChart-link-ae15"};